import { render } from "./Sidebar.vue?vue&type=template&id=2998f480&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=2998f480&lang=css&scoped=true"

import exportComponent from "D:\\CRUD Vue\\Puma Hammasi\\adidas-maincopy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2998f480"]])

export default __exports__